"use strict";

import React from 'react';

import { _I_, defineSimpleTerm } from 'components/locs';
import { GraphController } from 'components/generics';


// LogStream.enable("VIEWORDERSGRAPH");

function makePlottable( orders, total, fmt )  {
  let volume = 0;
  const result = orders.map( (order)  =>  {
                    volume  +=  order.count;
                    return  [  (+order.price),  volume,  fmt(order.price, volume)  ];
                  });

  if ( result.length == 1 )
    result.push(result[0]);

  if ( !result.length )
    result.push([0, 0, "N/A"]);

  return result;
}


const fmtSell = (price, volume)  =>  (`${volume} ${_I_("OrdersGraph.fmt.offers.sell")} ${price} ${_I_("OrdersGraph.fmt.andMore.sell")}`);
const fmtBuy  = (price, volume)  =>  (`${volume} ${_I_("OrdersGraph.fmt.offers.buy" )} ${price} ${_I_("OrdersGraph.fmt.andMore.buy")}`);


export default class ViewOrdersGraph extends React.Component {
  constructor(props)  {
    super(props);

    this.state = {
      "plotData": [[],[]],
      "plotOpt": null,
      "minPrice": 0,
      "maxPrice": 0,
      "maxOrders": 0
    };
  }

  componentWillMount() {
    this.setPlotOptions();
  }

  componentDidMount() {
    this.getPlotData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.getPlotData(nextProps);
  }


  makeRanges(buyGraph, sellGraph)  {
    const prices = [];
    const volumes = [];
    if (buyGraph.length)
    {
      const [ priceA, volA ] = buyGraph[0];
      const [ priceB, volB ] = buyGraph[buyGraph.length - 1];
      const priceC = (2*priceA)-priceB;
      const priceD = 2*Math.max(priceA, priceB, priceC);
      prices.push(priceA, priceB, priceC, priceD);
      volumes.push(volA, volB);
    }

    if (sellGraph.length)
    {
      const [ priceA, volA ] = sellGraph[0];
      const [ priceB, volB ] = sellGraph[sellGraph.length-1];
      const priceC = (2*priceA)-priceB;
      const priceD = 0.001;
      prices.push(priceA, priceB, priceC, priceD);
      volumes.push(volA, volB);
    }

    const fPrices = ( !prices.length ) ? [ 0 ] : prices.filter( (a)=>(a>0) );
    const fVolumes = ( !volumes.length ) ? [ 0 ] : volumes.filter( (a)=>(a>0) );

    const minPrice = Math.min(...fPrices);
    const maxPrice = Math.max(...fPrices);
    const centerPrice = (minPrice+maxPrice)/2;

    const minOrders = Math.min(...fVolumes);
    const maxOrders = Math.max(...fVolumes);
    const centerOrders = (minOrders+maxOrders)/2;

    return {
      "minPrice": centerPrice + (minPrice-centerPrice)*1.05,
      "maxPrice": centerPrice + (maxPrice-centerPrice)*1.05,
      "minOrders": centerOrders+ (minOrders-centerOrders)*1.05,
      "maxOrders": centerOrders+ (maxOrders-centerOrders)*1.05,
    };
  }


  getPlotData(props)  {
    let sellGraph = makePlottable(props.sellOrders, props.totalSell, fmtSell);
    let buyGraph  = makePlottable(props.buyOrders,  props.totalBuy,  fmtBuy);

    const ranges = this.makeRanges(buyGraph, sellGraph);

    this.setState({
      "plotData": [sellGraph, buyGraph],
      ...ranges
    }, () =>  {
      this.setPlotOptions();
    });
  }


  setPlotOptions() {
    let options = {
      renderer: $.jqplot.BarRenderer,
      rendererOptions: {
        fillToZero: true
      },
      title: {  text: _I_("OrdersGraph.plot.title"),  textAlign: 'center'  },
      gridPadding: {  left: 75,  right:45,  top:45  },
      axesDefaults: {  showTickMarks:false  },
      axes:{
        xaxis:{
          tickOptions: {
            formatString:'%0.2f',
            labelPosition:'start',
            showMark: false
          },
          min: this.state.minPrice,
          max: this.state.maxPrice
        },
        yaxis: {
          pad: 1,
          tickOptions: {
            formatString:'%d'
          },
          numberTicks: 7,
          min: this.state.minOrders,
          max: this.state.maxOrders
        }
      },
      grid: {
        gridLineColor: '#1b2939',
        borderColor: '#1b2939',
        background: '#101822'
      },
      cursor: {
        show: true,
        zoom: true,
        showTooltip: false
      },
      highlighter: {
        show: true,
        lineWidthAdjust: 2.5,
        sizeAdjust: 5,
        showTooltip: true,
        tooltipLocation: 'n',
        tooltipOffset: 20,
        fadeTooltip: true,
        yvalues: 2,
        formatString: "<span style=\"display: none\">%s%s</span>%s"
      },
      series: [
        {
          lineWidth:3,
          fill: true,
          fillAndStroke:true,
          fillAlpha: 0.3,
          markerOptions: {
            show: false,
            style:'circle'
          }
        },
        {
          lineWidth:3,
          fill: true,
          fillAndStroke:true,
          fillAlpha: 0.3,
          color:'#6b8fc3',
          markerOptions: {
            show: false,
            style:'circle'
          }
        }
      ],
      noDataIndicator: {
        show: true,
        indicator: 'No data',
        axes: {
          xaxis: { min: 0, max: 10, tickInterval: 2, show: false },
          yaxis: { min: 0, max: 12, tickInterval: 3, show: false }
        }
      },
      seriesColors: [ "#688F3E" ]
    };

    this.setState({ "plotOpt": options });
  }

  render() {
    let { plotData, plotOpt } = this.state;

    LogStream("VIEWORDERSGRAPH").log('render', plotData);

    return (
      <GraphController  plotOpt={plotOpt}
                        plotData={plotData} />
    );
  }
}


defineSimpleTerm( "OrdersGraph.plot.title",  "Buy/Sell orders",       {
  "ru_RU": "Покупка/Продажа",
  "cs_CZ": "Buy/Sell orders",
  "fr_FR": "Ordres d'achat/vente",
  "de_DE": "Aufträge kaufen/verkaufen",
  "it_IT": "Ordini di Vendita/Acquisto",
  "ko_KR": "구매/판매 주문",
  "pl_PL": "Polecenia kupna/sprzedaży",
  "pt_PT": "Buy/Sell orders",
  "es_ES": "Órdenes de compra/venta",
  "zh_CN": "购买/出售订单",
  "zh_TW": "購買/出售訂單"
} );


defineSimpleTerm( "OrdersGraph.fmt.offers.sell",  "sell offers\n<br/>price",       {
  "ru_RU": "ордер(а/ов)\n<br/>на продажу\n<br/>по",
  "cs_CZ": "sell offers\n<br/>price",
  "fr_FR": "offres de vente\n<br/>prix",
  "de_DE": "Aufträge verkaufen zum Preis von\n<br/>",
  "it_IT": "offerte di vendita\n<br/>prezzo",
  "ko_KR": "판매 주문\n<br/>가격",
  "pl_PL": "oferty sprzedaży\n<br/>cena",
  "pt_PT": "sell offers\n<br/>price",
  "es_ES": "vender ofertas \n<br/>precio",
  "zh_CN": "出售报价\n<br/>价格",
  "zh_TW": "出售報價\n<br/>價格"
} );


defineSimpleTerm( "OrdersGraph.fmt.andMore.sell",  "or lower",       {
  "ru_RU": "и ниже",
  "cs_CZ": "or lower",
  "fr_FR": "ou moins",
  "de_DE": "oder weniger",
  "it_IT": "o più bassi",
  "ko_KR": "이하",
  "pl_PL": "lub poniżej",
  "pt_PT": "or lower",
  "es_ES": "o menos",
  "zh_CN": "或更低",
  "zh_TW": "或更低"
} );


defineSimpleTerm( "OrdersGraph.fmt.offers.buy",  "buy offers\n<br/>price",       {
  "ru_RU": "ордер(а/ов)\n<br/>на покупку\n<br/>от",
  "cs_CZ": "buy offers\n<br/>price",
  "fr_FR": "offres d'achat\n<br/>prix",
  "de_DE": "Aufträge kaufen zum Preis von\n<br/>",
  "it_IT": "ordini d'acquisto\n<br/>prezzo",
  "ko_KR": "구매 주문\n<br/>가격",
  "pl_PL": "oferty kupna\n<br/>cena",
  "pt_PT": "buy offers\n<br/>price",
  "es_ES": "comprar ofertas\n<br/>precio",
  "zh_CN": "购买报价\n<br/>价格",
  "zh_TW": "購買報價\n<br/>價格"
} );


defineSimpleTerm( "OrdersGraph.fmt.andMore.buy",  "or higher",       {
  "ru_RU": "и выше",
  "cs_CZ": "or higher",
  "fr_FR": "ou plus",
  "de_DE": "der höher",
  "it_IT": "o più alto",
  "ko_KR": "이상",
  "pl_PL": "i powyżej",
  "pt_PT": "or higher",
  "es_ES": "y superior",
  "zh_CN": "或更高",
  "zh_TW": "或更高"
} );

